import InboxPage from '../InboxPage';
export default function AdminInboxPage() { return <InboxPage role="admin" />; }
